import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import config from '../../config';
import Title from './title';

const Statistics = () => {
  const user = useSelector(state => state.user.currentUser);
  const [stats, setStats] = useState(null);
  const [topCompanies, setTopCompanies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user?.role === 'super_admin') {
      loadStats();
    } else {
      setLoading(false);
    }
  }, [user]);

  const loadStats = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${config.apiUrl}/api/superadmin/dashboard`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
      setStats(res.data.statistics || {});
      setTopCompanies(res.data.topCompanies || []);
    } catch (error) {
      console.error('Ошибка загрузки статистики:', error);
      alert('Ошибка загрузки статистики');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="my-cargo mainAdmin">
        <Title text="Статистика" />
        <div className="loadpage">
          <p>Загрузка...</p>
        </div>
      </div>
    );
  }

  if (user?.role !== 'super_admin') {
    return (
      <div className="my-cargo mainAdmin">
        <Title text="Статистика" />
        <div className="notiofication">
          <br />
          <br />
          Статистика доступна только для супер-администратора
        </div>
      </div>
    );
  }

  return (
    <div className="my-cargo mainAdmin">
      <Title text="Статистика" />

      <div className="section-my-cargo">
        <div style={{ width: '100%', padding: '20px' }}>
          {stats && (
            <>
              {/* Stats Section */}
              <div className="stats-section" style={{ marginBottom: '40px' }}>
                <div className="stats-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px', marginBottom: '30px' }}>
                  <div className="stat-card" style={{ background: 'white', padding: '20px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', textAlign: 'center' }}>
                    <h3 style={{ margin: '0 0 10px 0', color: '#666', fontSize: '14px', textTransform: 'uppercase' }}>Всего компаний</h3>
                    <p style={{ margin: '0', fontSize: '32px', fontWeight: 'bold', color: '#333' }}>{stats.totalCompanies || 0}</p>
                  </div>
                  <div className="stat-card" style={{ background: 'white', padding: '20px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', textAlign: 'center' }}>
                    <h3 style={{ margin: '0 0 10px 0', color: '#666', fontSize: '14px', textTransform: 'uppercase' }}>Всего пользователей</h3>
                    <p style={{ margin: '0', fontSize: '32px', fontWeight: 'bold', color: '#333' }}>{stats.totalUsers || 0}</p>
                  </div>
                  <div className="stat-card" style={{ background: 'white', padding: '20px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', textAlign: 'center' }}>
                    <h3 style={{ margin: '0 0 10px 0', color: '#666', fontSize: '14px', textTransform: 'uppercase' }}>Активных компаний</h3>
                    <p style={{ margin: '0', fontSize: '32px', fontWeight: 'bold', color: '#333' }}>{stats.activeCompanies || 0}</p>
                  </div>
                  <div className="stat-card" style={{ background: 'white', padding: '20px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', textAlign: 'center' }}>
                    <h3 style={{ margin: '0 0 10px 0', color: '#666', fontSize: '14px', textTransform: 'uppercase' }}>Активных пользователей</h3>
                    <p style={{ margin: '0', fontSize: '32px', fontWeight: 'bold', color: '#333' }}>{stats.regularUsers || 0}</p>
                  </div>
                </div>

                {/* Top Companies */}
                {topCompanies && topCompanies.length > 0 && (
                  <div className="top-companies" style={{ background: 'white', padding: '20px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
                    <h3 style={{ marginBottom: '20px' }}>Топ компаний по количеству пользователей</h3>
                    {topCompanies.map((company, index) => (
                      <div key={company._id} className="company-rank" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0', borderBottom: '1px solid #eee' }}>
                        <span className="rank" style={{ fontWeight: 'bold', color: '#007bff', minWidth: '40px' }}>#{index + 1}</span>
                        <span className="company-name" style={{ flex: 1, fontWeight: 500 }}>{company.companyName}</span>
                        <span className="user-count" style={{ color: '#666', fontSize: '14px' }}>{company.userCount} пользователей</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Statistics;